import React from 'react';
import {observer} from 'mobx-react';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import moment from 'moment';
import {Spinner} from '../../components/spinners/Spinner'
import formatNotification from './NotificationFormatter';
import notificationsStore from './NotificationsStore';
import LinkBuilder from './LinkBuilder'
import defaultSessionStore from "../session/SessionStore";
import NotificationsSocket from "./NotificationsSocket";
import {ToastService} from "../../components/toasts/Toasts";

export const NotificationList = observer(class NotificationList extends React.PureComponent {
  socket

  constructor(props) {
    super(props);
    this.state = { open: false, hadChromeDome: false };
    this.componentRef = React.createRef();
    this.listRef = React.createRef();
  }

  componentWillMount() {
    document.addEventListener("mouseup", this.clickOutside, false);
    if(!notificationsStore.isInitializing) {
      this.socket = new NotificationsSocket(defaultSessionStore)
      this.socket.messageCallback = this.onMessage
      notificationsStore.init();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mouseup", this.clickOutside);
  }

  onMessage = (notification) => {
    const message = `A ${this.objectType(notification.trigger.eventType)} matching ${notification.name} ${this.getVerb(notification.trigger.eventType)}`;
    ToastService.notification(message)
    notificationsStore.processSocketNotification(notification);
  }

  clickOutside = (e) => {
    if (this.componentRef.current && !this.componentRef.current.contains(e.target) && this.state.open) {
      this.closeList();
    }
  };

  followAndDismissNotification(notification) {
    //todo deep linking logic
    const url = LinkBuilder.fromTrigger(notification.trigger);
    this.dismissNotification(notification)
    if(url) {
      window.location.href = url;
    }
  }

  dismissNotification(notification){
    notificationsStore.dismissNotification(notification);
    this.triggerResize();
    //this.closeList();
  }

  triggerResize() {
    window.dispatchEvent(new Event('resize'));
  }

  onClearAll() {
    notificationsStore.dismissAll();
    window.dispatchEvent(new Event('resize'));
  }

  render() {
    return <div className="d-flex align-items-center" style={{position: "relative"}}>
      <a id="notification-trigger" className="header-button" data-analyticsclick="Notifications List In Application Bar Button" onClick={() => this.state.open ? this.closeList() : this.openList() }>
        <div className="d-flex align-items-center">
          <i className="fas fa-bell d-flex justify-content-center m-auto" />
        </div>
      </a>
      {!notificationsStore.isLoading && !!notificationsStore.notifications.length && <div className="badge badge-secondary notification-badge">{notificationsStore.countUnread}</div>}
      <Popover positionFixed={true} popperClassName="notifications-popper" className="notification-popover" placement="top-end" fade={false} isOpen={this.state.open} target="notification-trigger" toggle={this.toggle}>
        {this.state.open && !notificationsStore.isLoading && <div ref={this.componentRef}>
          <PopoverHeader>
            <div className="d-flex pt-2 align-items-center">
              Notification
              <button type="button" className="btn btn-link ml-auto p-0" disabled={!notificationsStore.notifications.length} onClick={() => this.onClearAll()}>Clear All</button>
            </div>

          </PopoverHeader>
          <PopoverBody className="py-0">
            <div className="notification-list" ref={this.listRef}>
              { notificationsStore.notifications.map((notification, index) => <div className={`${index > 0 ? "border-top" : ""}`}>
                  {this.notificationContent(notification)}
                </div>
              )}
              { notificationsStore.isLoading ? <Spinner center={true} size={'md'} /> : ''}
              { !notificationsStore.notifications.length && <div className="py-4 pr-4">There are no active Notifications</div> }
            </div>
          </PopoverBody>
        </div>}
      </Popover>
    </div>
  }

  getVerb(eventType) {
    switch(eventType) {
      case "ReviewReceived":
        return "has been received";
      case "ReviewUpdated":
        return "has been updated"
      case "ReviewRespondedTo":
        return "has been responded to";
      case "GoogleQuestionAndAnswer":
        return "has been posted"
      case "CredentialExpired":
        return "has expired";
      case "WorkflowTaskApprovalNeeded":
        return "needs approval"
      case "WorkflowTaskCreated":
        return "has been created"
      case "WorkflowTaskAssignedToYou":
        return "has been assigned to you"
      case "WorkflowTaskCommentedOn":
        return "has been commented on"
      case "WorkflowTaskCompleted":
        return "is complete ";
      case "SocialPostCreated":
        return "has been posted";
    }
  }

  objectType(eventType) {
    switch(eventType) {
      case "ReviewReceived":
      case "ReviewUpdated":
      case "ReviewRespondedTo":
        return "review";
      case "GoogleQuestionAndAnswer":
        return "Google Q&A"
      case "CredentialExpired":
        return "credential";
      case "WorkflowTaskApprovalNeeded":
      case "WorkflowTaskCreated":
      case "WorkflowTaskAssignedToYou":
      case "WorkflowTaskCommentedOn":
      case "WorkflowTaskCompleted":
        return "task";
      case "SocialPostCreated":
        return "post";
    }
  }

  maybePlural(count, eventType) {
    if(count <= 1 || eventType === "GoogleQuestionAndAnswer") {
      return '';
    }
    return 's';
  }

  notificationContent(notification) {

    return <div key={notification._id} className="d-flex flex-row">
      <div onClick={() => this.followAndDismissNotification(notification)} className={"notification-item dropdown-item new" }>
        <strong className="title">{notification.name}</strong> <br />
        <div className="notification-description">{notification.count} {this.objectType(notification.trigger.eventType)}{this.maybePlural(notification.count, notification.trigger.eventType)} have arrived in the last {moment(notification.firstEvent ? notification.firstEvent : undefined).fromNow().replace(" ago", "")}</div>
      </div>
      <div className="d-flex align-items-center justify-content-center">
        <button type="button" className="close p-2" onClick={() => this.dismissNotification(notification)}>
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </div>
  }

  loadMore() {
    notificationsStore.loadMore()
  }
  //TODO - remove style toggle when refactor is complete
  closeList() {
    this.setState({open: false});
  }

  openList() {
    this.setState({open: true});
  }

});


export default new NotificationList()
